module.exports = __webpack_public_path__ + "static/media/CHAP01-OUVERTURE.fdfbe19b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP01-OUVERTURE.png
// module id = 267
// module chunks = 0